import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9545e4d6&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=9545e4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9545e4d6",
  null
  
)

export default component.exports